import { createMarkup } from '@interlayer/js/components/main/Games/createMarkup';
import React from 'react';
import style from './ShortGameDescription.scss';

export const ShortGameDescription = ({ title = '', description, isDangerouslySetInnerHTML = false, onTouchStart = () => {}, className = '' }) => {
    return (
        <div className={`${style.description} ${className}`} onTouchStart={onTouchStart}>
            {title && <h3>{title}</h3>}
            {isDangerouslySetInnerHTML ?
                <span dangerouslySetInnerHTML={createMarkup(description)}/> :
                <span>{description}</span>
            }
        </div>
    );
};
